import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import './Component_SmartDocs_Tabs.scss';
import { SmartDocsMode_Logs, SmartDocsMode_MDM, SmartDocsMode_Note, SmartDocsModes } from './types.js';
import { SmartDocsMode_ComponentMap, SmartDocsModes_LabelMap } from './consts.js';
export class Component_SmartDocs_Tabs extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.selectedTabId ??= SmartDocsMode_MDM;
        return state;
    }
    //######################### Logic #########################
    onTabClose = () => {
        if (this.state.selectedTabId !== SmartDocsMode_Note)
            return;
        this.setState({ selectedTabId: SmartDocsMode_Logs });
    };
    getTabs = () => {
        return SmartDocsModes.map(mode => ({
            title: SmartDocsModes_LabelMap[mode],
            uid: mode,
            content: SmartDocsMode_ComponentMap[mode](this.onTabClose)
        }));
    };
    //######################### Render #########################
    render() {
        const tabs = this.getTabs();
        return _jsx(TS_Tabs, { tabs: tabs, selectedTabId: this.state.selectedTabId, onSelected: mode => this.setState({ selectedTabId: mode }), className: 'component__smart-docs-tabs' });
    }
}
//# sourceMappingURL=Component_SmartDocs_Tabs.js.map